const HalfTextRight = {};

export default HalfTextRight